// extracted by mini-css-extract-plugin
export default {"box":"file-xml_box__-08Kv","download":"file-xml_download__ORND0","icon":"file-xml_icon__kXot2"};